import Model, { ID, Integer, MODEL_LEVEL } from 'src/models/model'

export default class ReportCategory extends Model {
  static name = 'ReportCategory'

  static versioned = true

  static level = MODEL_LEVEL.CIRCUIT

  static employeeRequiredPermissionCategories = [Model.permissionCategories.OperationsReporting]

  static atlasable = true

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String
      },
      displayOrder: {
        type: Integer,
        default: 9999
      },
      atlas: {
        type: Boolean,
        default: false
      }
    }

    this.queries = {
      reportCategories: {
        results: {
          reportCategories: [ReportCategory]
        }
      },
      atlasReportCategories: {
        results: {
          atlasReportCategories: [ReportCategory]
        }
      },
      reportCategory: {
        arguments: {
          id: {
            type: ID,
            required: true
          },
          atlas: {
            type: Boolean,
            required: false
          }
        },
        results: {
          reportCategory: ReportCategory
        }
      }
    }
  }
}
